function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import Heading from "@amzn/meridian/heading";
import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import { TEXT_TYPE, KEY_TERM_TYPE, IMAGE_TYPE, VIDEO_TYPE, LINK_TYPE } from "../../constants/common";
import TextContent from "./TextContent";
import KeyTermContent from "./KeyTermContent";
import ImageContent from "./ImageContent";
import VideoContent from "./VideoContent";
import LinkContent from "./LinkContent";
var ContentRenderer = function(param) {
    var title = param.title, content = param.content, contentType = param.contentType, onDownloadBtnClick = param.onDownloadBtnClick;
    var _obj;
    var contentRenderers = (_obj = {}, _define_property(_obj, TEXT_TYPE, /*#__PURE__*/ React.createElement(TextContent, {
        content: content
    })), _define_property(_obj, KEY_TERM_TYPE, /*#__PURE__*/ React.createElement(KeyTermContent, {
        content: content
    })), _define_property(_obj, IMAGE_TYPE, /*#__PURE__*/ React.createElement(ImageContent, {
        content: content
    })), _define_property(_obj, VIDEO_TYPE, /*#__PURE__*/ React.createElement(VideoContent, {
        content: content
    })), _define_property(_obj, LINK_TYPE, /*#__PURE__*/ React.createElement(LinkContent, {
        content: content,
        onDownloadBtnClick: onDownloadBtnClick
    })), _obj);
    return /*#__PURE__*/ React.createElement(Column, {
        spacing: "small"
    }, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Heading, {
        level: 2
    }, title)), /*#__PURE__*/ React.createElement(Row, null, contentRenderers[contentType]));
};
export default ContentRenderer;

//# sourceMappingURL=ContentRenderer.js.map